import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_RATES_HISTORY = 'FETCH_RATES_HISTORY'
export const RECEIVE_RATES_HISTORY = 'RECEIVE_RATES_HISTORY'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_RATES_HISTORY,
	receive: RECEIVE_RATES_HISTORY
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchRatesHistory = (filters, force) => fetch('ratesHistory', 'rates', actionTypes, {}, filters, force)
